module.exports = __webpack_public_path__ + "fonts/Lyon Arabic Display Regular.f7f90dd.otf";